import { MdCheckBox } from 'react-icons/md'

export default function CompletedTodo({complete}) {
  return (
    <div className="bless-card completed-card">
      <h6>{complete.date}</h6>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2>{complete.todo}</h2>
        <div><MdCheckBox size='40px' color='#B3B3B3'/></div>
      </div>
    </div>
  )
}
